export default __webpack_public_path__ + "static/media/EsilioPic2.6cac4d29.png";